export default function createLiveLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `live:${input.type}` });
    return {
        joined(details) {
            return log({
                type: "joined",
                details,
            });
        },
        left(details) {
            return log({
                type: "left",
                details,
            });
        },
    };
}
